import React from 'react';
import { nativeMockStyles, TakeActionPhones } from './OpenBroNativeMock';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const TakeActionSection = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';

  return (
    <section className="relative mt-12 lg:mt-20 px-[30px] lg:px-4">
      <div className="mx-auto max-w-[1140px]">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 flex flex-col justify-center lg:justify-start">
            <h3 className="text-center lg:text-left text-[13px] tracking-[0.35em] font-medium uppercase transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : '#1B2A4A' }}>
              {t.takeAction.label}
            </h3>
            <div className="relative">
              <h2 className="text-center lg:text-left text-[32px] lg:text-[48px] font-bold leading-[1.15] mt-2 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>
                {t.takeAction.title}
              </h2>
            </div>
            <div className="flex flex-col mx-auto lg:mx-0">
              {t.takeAction.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className="copy-text mt-6 max-w-md text-[15px] leading-[1.7] transition-colors duration-300"
                  style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.6)' : '#1B2A4A' }}
                  dangerouslySetInnerHTML={{ __html: p.text }}
                />
              ))}
              <div className="mt-6">
                <div onClick={() => startCheckout('take_action_cta')} className="cursor-pointer">
                  <button className={`w-full lg:w-min lg:min-w-[266px] text-xl border-2 p-[1px] group duration-300 transition-all font-bold ${isDark ? 'tech-glow' : ''}`} style={{ backgroundColor: isDark ? '#000000' : 'white', borderColor: isDark ? '#E6EBF2' : tc }}>
                    <div className="py-3.5 px-9 group-hover:bg-transparent duration-300 transition-all m-[1px]" style={{ backgroundColor: isDark ? '#E6EBF2' : tc, color: isDark ? '#000000' : 'white' }}>
                      {t.hero.cta}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="ob-phones lg:w-1/2 relative w-full" data-testid="phones-image">
            <TakeActionPhones />
          </div>
          <style>{`${nativeMockStyles}
            .ob-phones { height: 480px; display: flex; align-items: center; justify-content: center; }
            @media (min-width: 1024px) { .ob-phones { height: 520px; } }
          `}</style>
        </div>
      </div>
    </section>
  );
};

export default TakeActionSection;
